/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ToolMagicWandIcon32Regular = forwardRef('ToolMagicWandIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M19 1a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0V2a1 1 0 0 1 1-1Z" }),
        React.createElement("path", { d: "M19 18.5a1 1 0 0 1 1 1V24a1 1 0 1 1-2 0v-4.5a1 1 0 0 1 1-1Z" }),
        React.createElement("path", { d: "M19.707 12.293a1 1 0 0 1 0 1.414l-15 15a1 1 0 0 1-1.414-1.414l15-15a1 1 0 0 1 1.414 0Z" }),
        React.createElement("path", { d: "M27.485 5.929a1 1 0 0 0-1.414-1.414L22.536 8.05a1 1 0 1 0 1.414 1.414l3.535-3.535Z" }),
        React.createElement("path", { d: "M10.515 4.515a1 1 0 0 1 1.414 0l3.535 3.535a1 1 0 0 1-1.414 1.414L10.515 5.93a1 1 0 0 1 0-1.414Z" }),
        React.createElement("path", { d: "M22.536 16.535a1 1 0 0 1 1.414 0l3.535 3.536a1 1 0 0 1-1.414 1.414l-3.535-3.535a1 1 0 0 1 0-1.415Z" }),
        React.createElement("path", { d: "M12.5 12H8a1 1 0 1 0 0 2h4.5a1 1 0 1 0 0-2Z" }),
        React.createElement("path", { d: "M30 12h-5a1 1 0 1 0 0 2h5a1 1 0 1 0 0-2Z" })));
});
